export const EXPIRATION_DATE = "31/12/2026";

export * from "./countries";
export * from "./electronicInvoice";
export * from "./identityDocuments";
export * from "./priceSource";
